
import { Component, Prop, Vue } from 'vue-property-decorator';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import InfoBanner from '@/components/shared/suites/InfoBanner.vue';
import RestaurantSelector from '@/components/shared/RestaurantSelector.vue';

@Component<SelectLocationsModal>({
	components: {
		StandardModal,
		InfoBanner,
		RestaurantSelector
	}
})
export default class SelectLocationsModal extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) private showModal!: boolean;
	@Prop({ type: String, required: true }) private target!: 'menu' | 'settings';
	@Prop({ type: Array, required: false, default: () => [] }) private initialLocationIds!: string[];

	private selectedIds: string[] = [...this.initialLocationIds];

	private get infoBannerText(): string {
		return this.target === 'menu'
			? this.$t('multi_location_settings.select_locations.info_menu')
			: this.$t('multi_location_settings.select_locations.info_settings');
	}

	private submit(): void {
		this.$emit('submit', [...this.selectedIds]);
	}
}
